import React from 'react';
import { BaasicInput, Loader, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { observer } from 'mobx-react';
import { warehouseManagementType as wmsType } from 'common/constants';

const SellerEdit3PLCredentialsTemplate = ({
	t,
	viewStore,
	viewStore: {
		loading,
		form,
		seller,
		isUpdateAction,
		modalParams,
		warehouseManagementTypeDropdownStore,
		warehouseManagementType,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('SELLER3PLCREDENTIALS.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="card card--xsml card--wh-codes spc--bottom--sml">
						<div className="row">
							<div className="col col-sml-12 col-med-4 spc--bottom--sml">
								<label className="type--xsml type--wgt--bold type--uppercase type--color--grey-3">
									{t('SELLER3PLCREDENTIALS.SELLER')}
								</label>
								<p className="type--lrg type--wgt--bold">{seller || isUpdateAction ? seller.applicationTitle : '-'}</p>
							</div>
							<div className="col col-sml-12 col-med-4 spc--bottom--sml">
								<label className="type--xsml type--wgt--bold type--uppercase type--color--grey-3">
									{t('WAREHOUSEVIEW.WAREHOUSEMANAGEMENTTYPE')}
								</label>
								<BaasicDropdown dropdownStore={warehouseManagementTypeDropdownStore} isClearable={true} />
							</div>
						</div>
					</div>
					{warehouseManagementType && (
						<table className="table--secondary table--secondary--seller spc--bottom--sml spc--top--sml">
							<colgroup>
								<col />
								<col width="180" />
							</colgroup>
							<thead>
								{/* th value needs to be hardcoded. */}
								{warehouseManagementType && (
									<TableHeader t={t} warehouseManagementType={viewStore.warehouseManagementType} />
								)}
							</thead>
							<tbody>
								{warehouseManagementType &&
									form.$('sellerCredentials').map(item => {
										return item.$('warehouseManagementTypeId').value === warehouseManagementType.value ? (
											<TableBody
												key={item.id}
												warehouseManagementType={viewStore.warehouseManagementType}
												item={item}
												viewStore={viewStore}
											/>
										) : null;
									})}
							</tbody>
						</table>
					)}
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--right--tny spc--bottom--sml" type="submit">
						{t('SAVE')}
					</button>
					<button className="btn btn--med btn--outline spc--bottom--sml" onClick={modalParams.close}>
						{t('CANCEL')}
					</button>
				</div>
			</form>
		</section>
	);
};

const TableHeader = observer(({ t, warehouseManagementType }) => {
	switch (warehouseManagementType.extra.abrv) {
		case wmsType.daVinci:
			return (
				<tr>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.WAREHOUSE')}</th>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.VENDORID')}</th>
					<th></th>
					<th></th>
				</tr>
			);
		case wmsType.extensiv:
			return (
				<tr>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.WAREHOUSE')}</th>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.SELLERID')}</th>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.CLIENTID')}</th>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.CLIENTSECRET')}</th>
				</tr>
			);
		case wmsType.zethcon:
			return (
				<tr>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.WAREHOUSE')}</th>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.CUSTOMERID')}</th>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.USERNAME')}</th>
					<th className="border">{t('ORGANIZATION.WAREHOUSEMANAGEMENT.PASSWORD')}</th>
				</tr>
			);
	}
});

const TableBody = observer(({ warehouseManagementType, item, viewStore }) => {
	switch (warehouseManagementType.extra.abrv) {
		case wmsType.daVinci:
			return (
				<tr key={item.id}>
					<td>
						<label className="type--base type--wgt--bold type--color--text">{item.$('warehouseName').value}</label>
					</td>
					<td>
						<BaasicInput
							noSpc
							field={item.$('vendorId')}
							innerClassName="input--single-row"
							iconClass="fa fa-search header__search__icon k-custom-clickable"
							onIconClick={() => viewStore.openDaVinciBusinessPartnersModal(item)}
						/>
					</td>
				</tr>
			);
		case wmsType.extensiv:
			return (
				<tr key={item.id}>
					<td>
						<label className="type--base type--wgt--bold type--color--text">{item.$('warehouseName').value}</label>
					</td>
					<td>
						<BaasicInput noSpc field={item.$('customerId')} />
					</td>
					<td>
						<BaasicInput noSpc field={item.$('clientId')} />
					</td>
					<td>
						<BaasicInput noSpc field={item.$('clientSecret')} />
					</td>
				</tr>
			);
		case wmsType.zethcon:
			return (
				<tr key={item.id}>
					<td>
						<label className="type--base type--wgt--bold type--color--text">{item.$('warehouseName').value}</label>
					</td>
					<td>
						<BaasicInput noSpc field={item.$('customerId')} />
					</td>
					<td>
						<BaasicInput noSpc field={item.$('username')} />
					</td>
					<td>
						<BaasicInput noSpc field={item.$('password')} />
					</td>
				</tr>
			);
	}
});

export default defaultTemplate(SellerEdit3PLCredentialsTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/seller/pages/SellerEdit3PLCredentialsTemplate.jsx